import { FormConfigInterface } from './interfaces/form-config.interface';

export const IT_CONFIG: FormConfigInterface = {
  completeProfile: [
    { Name: 'given_name', Required: () => true, Type: 'text', Order: 1, Hide: () => false },
    { Name: 'family_name', Required: () => true, Type: 'text', Order: 2, Hide: () => false },
    { Name: 'email', Required: () => true, Type: 'text', Order: 3, Hide: () => false, Readonly: true, },
    { Name: 'phone', Required: () => true, Type: 'phone', Order: 4, Hide: () => false },
    { Name: 'locale', Required: () => true, Type: 'locale-picker', Order: 5, Hide: () => false },
    { Name: 'gender', Required: () => true, Type: 'gender-picker', Order: 6, Hide: () => false },
  ],
  personalInfo: [
    { Name: 'given_name', Required: () => true, Type: 'text', Order: 1, Readonly: true, Hide: () => false, },
    { Name: 'family_name', Required: () => true, Type: 'text', Order: 2, Readonly: true, Hide: () => false, },
    { Name: 'fiscal_code', Required: () => true, Type: 'text', Order: 3, Readonly: true, Hide: () => false, },
    { Name: 'date_of_birth', Required: () => true, Type: 'date-picker', Order: 4, Readonly: true, Hide: () => false, CustomLabelTranslationKey: 'dobLabel2', },
    { Name: 'gender', Required: () => true, Type: 'gender-picker', Order: 5, Readonly: true, Hide: () => false, CustomLabelTranslationKey: 'genderLabel2', },
  ],
  contact: [
    { Name: 'address', Required: () => false, Type: 'text', Order: 0, Hide: () => false },
    { Name: 'house_number', Required: () => false, Type: 'text', Order: 0, Hide: () => false },
    { Name: 'zipcode', Required: () => false, Type: 'text', Order: 0, Hide: () => false, CustomLabelTranslationKey: 'postalCodeLabel', },
    { Name: 'city', Required: () => false, Type: 'text', Order: 0, Hide: () => false },
    { Name: 'phone', Required: () => true, Type: 'phone', Order: 0, Hide: () => false, CustomLabelTranslationKey: 'phoneLabel', },
    { Name: 'email', Required: () => true, Type: 'text', Order: 0, Readonly: true, Hide: () => false, CustomLabelTranslationKey: 'email', },
  ],
};
